import React from "react";
import "./HeroIntro.css";
type Props = {
  title: string;
  subtitle?: string;
};

const HeroIntro: React.FC<Props> = ({ title, subtitle }) => {

  return (
    <section className="hero-intro">
      <div className="hero-intro__container">
        <h1 className="hero-intro__title">
          {title}
        </h1>
        {subtitle && (
          <p className="hero-intro__text">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
};

export default HeroIntro;
